import { getProductState, getProductStateByPath } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import cloneDeep from "lodash/cloneDeep"

// it currently doesn't appear that we need to memoize this. We may need to later after we resolve some issues with DataState not caching results as well as it could.
export function ucsGetComputedVariantProduct(
    parentProductState: ReturnType<typeof getProductStateByPath>,
    variantProductState: ReturnType<typeof getProductState>,
) {
    if (!variantProductState.value) {
        return parentProductState;
    }

    if (!parentProductState.value) {
        return parentProductState;
    }

    if (parentProductState.value.id === variantProductState.value.id) {
        return parentProductState;
    }

    const { value: variantProduct } = variantProductState;

    const computedProduct = cloneDeep(parentProductState.value);
    Object.assign(computedProduct, {
        productNumber: variantProduct.productNumber,
        customerProductNumber: variantProduct.customerProductNumber,
        smallImagePath: variantProduct.smallImagePath,
        mediumImagePath: variantProduct.mediumImagePath,
        largeImagePath: variantProduct.largeImagePath,
        imageAltText: variantProduct.imageAltText,
        id: variantProduct.id,
        quoteRequired: variantProduct.quoteRequired,
        productTitle: variantProduct.productTitle,
        images: variantProduct.images,
        trackInventory: variantProduct.trackInventory,
        minimumOrderQty: variantProduct.minimumOrderQty,
        canonicalUrl: variantProduct.canonicalUrl,
        unitOfMeasures: variantProduct.unitOfMeasures,
        isVariantParent: false,
        canAddToWishlist: variantProduct.canAddToWishlist,
        cantBuy: variantProduct.cantBuy,
        detail: variantProduct.detail, 
    });

    return {
        isLoading: parentProductState.isLoading,
        id: variantProductState.id,
        value: computedProduct,
    };
}
